/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

type FlagIconProps = SvgIconProps & {
  stroke?: string;
  fill?: string;
};

export default function FlagIcon({ stroke = 'currentColor', fill = 'none', ...props }: FlagIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path d="M6 4V16" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" fill={fill} />
      <path
        d="M6 5.2H13.6L12 9.2L13.6 12.6H6"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill={fill}
      />
    </SvgIcon>
  );
}
